(function () {
  'use strict';

  function prefill() {
    if (!window.URLSearchParams) return;
    var topic = new URLSearchParams(window.location.search).get('topic');
    if (!topic) return;

    var selects = document.querySelectorAll('[data-bt-topic-select]');
    Array.prototype.forEach.call(selects, function (select) {
      var match = Array.prototype.some.call(select.options, function (option) {
        return option.value === topic;
      });
      if (!match) return;
      select.value = topic;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prefill);
  } else {
    prefill();
  }
})();
